module.exports = __webpack_public_path__ + "img/exit_11.fdc3dad9.svg";